import { Star } from "lucide-react"

import { cn } from "@/lib/utils"

// ★ average + review count. Customer reviews only feed the average (the headline
// rating), so `count` is the customer-review count. A freelancer with no rating
// yet reads as a quiet "New · no reviews yet" rather than faking zero stars.
export default function StarRating({ rating, count, className, showCount = true }) {
  if (rating == null) {
    return (
      <span className={cn("text-[11.5px] font-medium text-ink-3", className)}>
        No reviews yet
      </span>
    )
  }

  const full = Math.round(rating)

  return (
    <span className={cn("inline-flex items-center gap-[2px]", className)}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          className={cn("size-[13px]", i <= full ? "fill-needs-you text-needs-you" : "fill-line-2 text-line-2")}
          strokeWidth={0}
        />
      ))}
      <b className="ml-[5px] font-display text-[12.5px] font-bold text-foreground">
        {rating.toFixed(1)}
      </b>
      {showCount && count != null && (
        <span className="ml-1 text-[11.5px] text-ink-3">({count})</span>
      )}
    </span>
  )
}
